module.exports = __webpack_public_path__ + "static/img/yk8400.5a257d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/yk8400.png
// module id = 5hAo
// module chunks = 1